<ng-container *ngIf="nearbySorted && nearbySorted.length > 0">
  <div class="bb-light mt-3 mb-5"></div>
  <div class="px-4">
    <div class="container">
      <h2 class="equipment-rentals-near-by-header">Nearby Locations</h2>
      <h2 class="equipment-rentals-near-by-subheader font-weight-light">
        Top cities for {{ primaryType == "all" ? "equipment" : primaryType }} {{ collectionLabel }} near {{ cityState }}
      </h2>

      <div class="row">
        <ng-container *ngFor="let city of nearbySorted">
          <div class="col-md-4">
            <a class="card bg-light-grey p-3 mb-3 inherit cursor-pointer" [routerLink]="routerLinkForCity(city.searchResultsCity)">
              <div class="media-body">
                <h5 class="mt-0 mb-1">
                  {{ primaryType == "all" ? "Equipment" : primaryType }} {{ collectionLabelTitleCase }} in <b>{{ city.name }}, {{ city.state }}</b>
                </h5>
                {{ city.distance | number: "1.0-0" }} mi away
              </div>
            </a>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
